function initSlider() {
	$('.flexslider-slide-list').flexslider({
		animation: "slide",
		controlNav: true,
		directionNav: true,
		animationLoop: false,
		slideshow: false,
		itemWidth: 360,
		minItems: 1,
		maxItems: 3,
		move: 1,
		initAt: 4,
		start: function(slider) {
			//console.log(slider);
			// console.log($(slider));
			if (typeof slider.container !== 'undefined') {
				$(slider.container[0]).find('.card').css('min-height', slider.container[0].clientHeight);
			} else {
				if (slider.context) {
					$(slider).find('.slides').addClass('row row-flex row-cols-md-3');
					$(slider).find('.slides > li').addClass('col');
					$(slider).find('.slides > li > div').removeClass('slide-list-item');

					var maxHeight = 0;
					$(slider).find('.card').each(function() {
						var thisH = $(this).height();
						if (thisH > maxHeight) { maxHeight = thisH; }
					});
					$(slider).find('.card').height(maxHeight);
				}
			}			
		}
	});	
}

function htmlDecode(input) {
	var doc = new DOMParser().parseFromString(input, "text/html");
	return doc.documentElement.textContent;
}

function getUrlParam(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
};

$(document).ready(function() {

	// Navigation Flyout Start
	$('.nav-horizontal .has-dropdown > a').on('click', function(e) {
		var dropDown = $(this);
		var isActive = dropDown.parent().hasClass('nav-flyout--in');

		$('.nav-horizontal .has-dropdown').removeClass('nav-flyout--in');
		$('body').removeClass('body-nav-flyout--in');
		if (!isActive) {
			dropDown.parent().addClass('nav-flyout--in');
			$('body').addClass('body-nav-flyout--in');
		}

		dropDown.next('.nav-flyout').find('.tab-link').each(function() {
			if (!$(this).hasClass('moved')) {
				$(this.hash).detach().appendTo($('#' + $(this).data('container')));
				$(this).addClass('moved');
			}
		});
		e.preventDefault();
	});

	$('.tabs-flyout .tab-link').on('click', function(e) {
		$(this).tab('show');
	  	e.preventDefault();
  	});

	$('.nav-flyout__close').on('click', function(e) {
		e.preventDefault();
		$(this).closest('.has-dropdown').removeClass('nav-flyout--in');
		$('body').removeClass('body-nav-flyout--in');
	});

	var glossaryData;
	if ($('.glossary').length > 0) {
		$.getJSON(window.glossaryJson, function (data) {
			glossaryData = data;
		});
	}

	$('.glossary').popover({
		placement: 'auto top',
		html: true,
		title: function() {
			return $(this).html().trim();
		},
		content: function() {
			var glossaryTitle = $(this).html().trim();
			var glossaryEntries = glossaryData.filter(function(data) {
				return data.title === glossaryTitle;
			});
			var glossaryEntry = glossaryEntries[0];
			var extract = '';

			if (glossaryEntry) {
				extract += jQuery.truncate(htmlDecode(glossaryEntry.extract), { length: 300, words: true });
				extract += '<a class="popover__link" target="_blank" href="' + glossaryEntry.link + '?collapse=' + glossaryEntry.guid + '"></a>';
			}

			return extract;
		},
		template: '<div class="popover wysiwyg" role="tooltip"><div class="arrow"></div><div class="popover-body"><h2 class="popover-title"></h2><div class="popover-content"></div></div></div>'
	});

	$(document).on('click', function (e) {
		$('.glossary').each(function () {
			if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {                
				(($(this).popover('hide').data('bs.popover')||{}).inState||{}).click = false
			}
		});
	});

	$('.link-list a[href^="http"], .linklist a[href^="http"], .links-horizontal a[href^="http"], .card__cta a[href^="http"], .crosslink a[href^="http"], .teaser .readmore a[href^="http"], .grid .grid__item a[href^="http"]').attr('target', '_blank');

	initSlider();

	$.validator.methods.email = function( value, element ) {
		return this.optional( element ) || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( value );
	}

	$(".js-validate").validate({
		debug: true,
		email: true,
		errorClass: "invalid",
		submitHandler: function(form) {
			form.submit();
			},
		errorPlacement: function (error,element) { return true;}, 
		highlight: function (element, errorClass, validClass) {
				if(element.id != ""){
					$(element.form).find("#"+element.id).closest('.form-group')
						.addClass(errorClass);
				}
				if(element.id == "form_email"){
					$("#email_format_error").show();
				}	
			},
		unhighlight: function (element, errorClass, validClass) {
			if(element.id != ""){
				$(element.form).find("#"+element.id).closest('.form-group')
				.removeClass(errorClass);
			}
			if(element.id == "form_email"){
				$("#email_format_error").hide();
			}	
		},
		rules: {
			hbsevent_email: {
				required: true,
				email: true,
			}
		},
		messages: {
			hbsevent_email: {
				email: "Bitte eine E-Mail im gültigen Format angeben!"
			}
		}
	});

	$.fn.isInViewport = function() {
	  var elementTop = $(this).offset().top;
	  var elementBottom = elementTop + $(this).outerHeight();

	  var viewportTop = $(window).scrollTop();
	  var viewportBottom = viewportTop + $(window).height();

	  return elementBottom > viewportTop && elementTop < viewportBottom;
	};

	$(".js-scroll-to").on('click', function(e) {
		e.preventDefault();
		var  a = $($(this).attr('href'));

		$('html,body').animate({
			scrollTop: a.offset().top - 120
		}, 500);
	});

	$('.js-close-menu').on('click',function(e){
			e.preventDefault();
			$('.page-wrapper').removeClass('offcanvas-in');
	});

	$('.js-second-level').on('click',function(e){
			e.preventDefault();
			$(this).closest('.has-second-level').toggleClass('second-level-in');
	});

	// MBIX
	$('.mbix-calculator').mbix({
		development: false
	});

	// Pay Ratio
	$('.tool-pay-ratio').payRatio();

	// Payment Calculator
	$('.payment-calculator').paymentCalculator({
		afterAddingForm: function() {
			$('.regex-num').on('input', function() {
				this.value = this.value.replace(/[^0-9]/g,'');
			});
			$('.regex-thsnd').on('input', function() {
				this.value = this.value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
			});
			$('[data-toggle="popover"]').popover({
				'trigger': 'click'
			}).click(function(e) {
				e.preventDefault();
				$(this).tooltip('toggle');
			});
		}
	});

	// Print Button, add Class mbix-print to body
	$('.btn-mbix-print').on('click', function() {
	  $('body').addClass('mbix-print');
	  window.print();
	});

	$('.output-range').each(function() {
	  var output = '#' + $(this).data('output');
	  $(output).val(this.value);
	  $(this).on('input change', function() {
	    $(output).val(this.value);
	  });
	});

	$('.regex-num').on('input', function() {
	  this.value = this.value.replace(/[^0-9]/g,'');
	});

	$('.regex-max').on('input', function() {
		if (this.value > 100) {
			this.value = 100;
		}
	});

	$('.regex-thsnd').on('input', function() {
		this.value = this.value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	});

	// MPB
	$('.flexslider-stage').flexslider({
		animation: "fade",
		controlNav: true,
		directionNav: true,
		start: function(slider) {
			if (typeof smartEdit != 'undefined' && smartEdit == true && slider.count > 0) {
				slider.pause();
				$('.flex-direction-nav').hide();
				var slide = $.cookie("slider");
				var slides = slider.count;
				if (typeof slide != 'undefined' && slide < slides) {
						slider.flexAnimate(slide);
				}
			}
		},
		after: function(slider){
			if (typeof smartEdit != 'undefined' && smartEdit == true) {
				var slide = slider.currentSlide;
				$.cookie("slider", slide);
			}
		}
	});

	$(".noscript").hide();

	$.removeCookie('cookieconsent_status', { path: '/' });

	// Mobile Navigation
	$('#toggleMenu').click(function(event) {
		event.preventDefault();
		$('.page-wrapper').addClass('offcanvas-in').removeClass('widgets-in');
	});

  // Comment Counter (Workaround for "0" > "")
  var ccinterval;
  ccinterval = setInterval(function(){
      var c = jQuery('.box-sharing span.comments-counter');
      if (c.text() == "0"){
          c.text("");
          clearInterval(ccinterval);
      }
  }, 100);

	$('#lockLayer').click(function() {
		$('.page-wrapper').removeClass('offcanvas-in widgets-in');
	});

	// Image Gallery
	$('.gallery-item').magnificPopup({
	  type: 'image',
	  gallery: {
		  enabled: true, // set to true to enable gallery
		  preload: [0,2], // read about this option in next Lazy-loading section
		  navigateByImgClick: true,
		  arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
		  tPrev: 'Vorheriges (Linke Pfeil-Taste)', // title for left button
		  tNext: 'Nächstes (Rechte Pfeil-Taste)', // title for right button
		  tCounter: '<span class="mfp-counter">%curr% von %total%</span>' // markup of counter
		}
	});

	$('.image-zoom').magnificPopup({
	  type: 'image',
	  mainClass: 'mfp-with-zoom', // this class is for CSS animation below
      zoom: {
        enabled: true, // By default it's false, so don't forget to enable it
        duration: 300, // duration of the effect, in milliseconds
        easing: 'ease-in-out', // CSS transition easing function
        // The "opener" function should return the element from which popup will be zoomed in
        // and to which popup will be scaled down
        // By defailt it looks for an image tag:
        opener: function(openerElement) {
          // openerElement is the element on which popup was initialized, in this case its <a> tag
          // you don't need to add "opener" option if this code matches your needs, it's defailt one.
          return openerElement.is('img') ? openerElement : openerElement.find('img');
        }
      }
	});

	$('.js-file-ending').each(function() {
		var fileName = $(this).closest('a').attr('href');
		var fileEnding = fileName.substring(fileName.lastIndexOf('.') + 1).toUpperCase();
		$(this).append(fileEnding);
	});

	// Empty Details
	$('.details dd:empty').hide().prev('dt').hide();

	// Hide Author if empty
	$('.subtitle.author').not(":has(span)").hide();

	// Hover Fix Touch Devices
	$('.has-dropdown').on("touchstart", function (e) {
    'use strict';
    var link = $(this);
    if (link.hasClass('hover')) {
        return true;
    } else {
        link.addClass('hover');
        $('.has-dropdown').not(this).removeClass('hover');
        e.preventDefault();
        return false;
    }
	});

	// Enable Popups
	$('[data-toggle="popover"]').popover({'trigger': 'click'}).click(function(e) {
		e.preventDefault();
		$(this).tooltip('toggle');
	});
	
	// Expand filter on mobile devices
	$('.btn-toggle-filter').click(function(event) {
		event.preventDefault();
		$(this).parent().fadeOut(150);
			var openContainer = $(this).data('opencontainer');
		$(openContainer).addClass('in');
	});

	// Scroll Top Waypoint
	$('.sticky-top-link').click(function(e) {
		$('html, body').animate({scrollTop : 0}, 300);
	  	e.preventDefault();
	});

	$('body').waypoint(function() {
	  $('.sticky-top-link').toggleClass('invisible');
	}, { offset: -400 });

	// Tabs
	$('.tabs .nav-tabs li:first-child, .tabs .tab-content .tab-pane:first-child').addClass('active');

	$('.tabs .nav-tabs a').click(function(e) {
	  e.preventDefault();
	  $(this).tab('show');
	});

	// Placeholder
	$('input, textarea').placeholder();

	// Card Navigation
	$('.section-card').each(function() {
		var elements = $(this).find('.card-list li'),
			totalCount = elements.length,
			elementsArray = elements.toArray(),
			activeCount,
			prevElement,
			nextElement;

		$.each(elements, function(key, element) {
			if (element.className == 'active') {
				activeCount = key;
			}
		});

		prevElement = elementsArray[activeCount-1];
		nextElement = elementsArray[activeCount+1];

		$('.paging').each(function() {

			if (typeof prevElement != "undefined") {
				$(this).find('.btn-prev').attr('href', prevElement.children[0].href);
			} else {
				$(this).find('.btn-prev').hide();
			}

			if (typeof nextElement != "undefined") {
				$(this).find('.btn-next').attr('href', nextElement.children[0].href);
			} else {
				$(this).find('.btn-next').hide();
			}

			$(this).find('.counter').html(activeCount + 1 + ' von ' + totalCount);

		});
	});

	$('.login-button').click(function(e) {
		$('.modal').modal('hide');
		setTimeout(function() {
			$('html, body').animate({scrollTop : 0}, 300);
			$('.btn-login').dropdown('toggle');
		}, 300);
		e.preventDefault();
	});

	// overflow scroll table
	$('.touch .wysiwyg table').each(function() {
		$(this).wrap('<div class="table-wrap"/>');
	});

	// Toggle Function footer
	$('#showFunctionFooter').on('click', function(){
		$('#functionFooter').toggleClass('open');
	});

	// Tool Navigation
	$('.page-nav').each(function() {
    if (typeof toolNav !== "undefined") {
      var prev = -1;
      var next = -1;
      var last = toolNav.length - 1;

      for (var i in toolNav) {
        var active = toolNav[i].active;
        var current = parseInt(i);
        if (active) {
          prev = current - 1;
          next = current + 1;
          break;
        }
      }

      if (prev >= 0 && prev <= last) {
        $(this).prepend('<a class="page-link page-prev" href="' + toolNav[prev].href + '"><i class="icon icon-prev"></i><span class="link-text">' + toolNav[prev].title + '</span></a>');
      } else {
		$(this).prepend('<span class="page-link page-prev"/>');
	  }

      if (next >= 0 && next <= last) {
        $(this).append('<a class="page-link page-next" href="' + toolNav[next].href + '"><i class="icon icon-next"></i><span class="link-text">' + toolNav[next].title + '</span></a>');
      } else {
		$(this).append('<span class="page-link page-next"/>');
	  }
    }
  });

	$('.accordion .collapse-title').on('click', function(e) {
		var collapser = $(this);
		var topOffset = 100;
		var fixedHeader = $('body').hasClass('body-sz');
		if (fixedHeader) {
			topOffset = 250;
		}
		$('.accordion .collapse.in').collapse('hide');
		setTimeout(function() {
			$('html, body').animate({scrollTop: collapser.offset().top - topOffset}, 300);
			if (scrollnav.data) {
				scrollnav.updatePositions();
			}
		}, 500);
	});

	if (getUrlParam('collapse') && $('[data-guid="' + getUrlParam('collapse') + '"]').length === 1) {
		$('[data-guid="' + getUrlParam('collapse') + '"] .collapse').collapse();
		setTimeout(function() {
			$('html, body').animate({scrollTop: $('[data-guid="' + getUrlParam('collapse') + '"]').offset().top - 100}, 300);
		}, 500);
	}

	// Toggle Kartenstapel Inhaltsverzeichnis
	$('.card-header__toggle').on('click', function() {
		$('.card-nav').toggleClass('card-nav--expanded');
	});

	splitElements('.separate-links', ', ');

	// Focus on search input
	$('.site-navigation__search .dropdown').on('shown.bs.dropdown', function() {
		$('.onsite-search-input').focus();
	});
	$('.site-navigation__search .dropdown').on('hidden.bs.dropdown', function() {
		$('a#dropdownSearch').focus();
	});

	// Wrap Tables With Overflow
	$('.wysiwyg > table').wrap('<div class="table-wrapper"></div>"');

	// Kartenstapelnavigation on mobile Screens
	$('.kartenstapel-nav__button--sm').on('click', function() {
		$('.area--kartenstapel-nav').addClass('in');
		$('body').addClass('kartenstapel-nav--in');
	});
	$('.kartenstapel-nav__close').on('click', function() {
		$('.area--kartenstapel-nav').removeClass('in');
		$('body').removeClass('kartenstapel-nav--in');
	});

	// Detect if sticky element is pinned

	var siteTopBar = $(".site-top-bar");
	$(window).scroll(function() {    
		var scroll = $(window).scrollTop();
		if (scroll >= 50) {
			siteTopBar.addClass("is-pinned");
		} else {
			siteTopBar.removeClass("is-pinned");
		}
	});

	// const stickyTopBar = document.querySelector(".site-top-bar")
	// const observer = new IntersectionObserver( 
	// ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
	// { threshold: [1] }
	// );

	// if (stickyTopBar) {
	// 	observer.observe(stickyTopBar);
	// }

	if (window.location.hash) {
		if (!window.location.hash.startsWith('#scroll-nav') && $(window.location.hash).length === 1) {
			setTimeout(function() {
				$('html, body').animate({
					scrollTop: $(window.location.hash).offset().top - 150
				}, 300);
			}, 300);
		}
	}

	$('.wysiwyg a, .card--cta-link a').on('click', function(e) {
		if (this.pathname === window.location.pathname) {
			if (this.hash && $(this.hash).length === 1) {
				$('html, body').animate({
					scrollTop: $(this.hash).offset().top - 150
				}, 300);
			}
			//e.preventDefault();
			e.stopPropagation();
		}
	});

	$('.section--banner.active').each(function() {
		let banner = $(this);
		let bannerDismiss = banner.find('.button--dismiss');
		let bannerCookie = $.cookie('banner_' + banner.attr('id'));

		bannerDismiss.on('click', function(e) {
			banner.hide();
			// für ein Jahr speichern - für Session wäre es ohne Angabe der Tage (falls Abhängigkeit zu UC)
			$.cookie('banner_' + banner.attr('id'), 'dismissed', { expires: 365, path: '/' });
			e.preventDefault();
		});

		if (bannerCookie !== 'dismissed') {
			setTimeout(function() {
				banner.show();
			}, 0);
		}
	});

	$('.section--banner-nl').each(function() {
		let banner = $(this);
		let container = $(this).attr('id');
		let bannerLink = banner.find('.button--cta');

		$.ajax({
			url: window.userStatus,
			cache: false,
			success: function (data) { 
				if (data.isLoggedIn && !data.hasNewsletter && container === 'no-nl') {
					banner.show();
					bannerLink.on('click', function(e) {
						$.ajax({
							url: window.aboNl,
							cache: false,
							success: function (data) { 
								if (data.subscribed) {
									bannerLink.text('Abonnement im Profil verwalten');
									bannerLink.attr('href', '/html/profil.html');
									bannerLink.addClass('button--cta-white');
									bannerLink.off();
								} else {
									// nicht erfolgreich
								}
							}
						});
						e.preventDefault();
					});
				}
				if (!data.isLoggedIn && container === 'no-login') {
					banner.show();
				}
			}
		});
	});

// end of document ready
});

$(window).load(function() {
	// Scroll Navigation Kartenstapel
	// via https://scrollnav.com
	const content = document.querySelector('.artikel--kartenstapel');
	const insertTarget = document.querySelector('.kartenstapel-nav__list');

	scrollnav.init(content, {
		debug: false,
		sections: '.scroll-title',
		subSections: '.scroll-title-sub',
		insertTarget: insertTarget,
		insertLocation: 'append',
		onScroll: function() {
			$('.area--kartenstapel-nav').removeClass('in'); // mobile
			$('body').removeClass('kartenstapel-nav--in'); // mobile
		},
		onInit: function() {

			var config = { attributes: true, childList: true, characterData: true };

			$('.scroll-nav__item').each(function () {
				var target = this;
				var $target = $(this);
				var observer = new MutationObserver(function(mutations) {
					mutations.forEach(function(mutation) {
						if ($target.hasClass('scroll-nav__item--active')) {
							$target.addClass('scroll-nav__item--open');
							$target.siblings().removeClass('scroll-nav__item--open');
						}
					});
				});
				observer.observe(target, config);
			});

			$('.scroll-nav__sub-item').each(function () {
				var target = this;
				var $target = $(this);
				var observer = new MutationObserver(function(mutations) {
					mutations.forEach(function(mutation) {
						if ($target.hasClass('scroll-nav__item--active')) {
							$target.closest('.scroll-nav__item').addClass('scroll-nav__item--open');
							$target.closest('.scroll-nav__item').siblings().removeClass('scroll-nav__item--open');
						}
					});
				});
				observer.observe(target, config);
			});

			if (window.location.hash) {
				if (window.location.hash.startsWith('#scroll-nav') && $(window.location.hash).length === 1) {
					$('html, body').animate({
						scrollTop: $(window.location.hash).offset().top - 150
					}, 300);
				}
			}
		}
	});
});